import React, { useEffect, useState } from "react";
import { Modal, Button, Spinner } from "react-bootstrap";
import Appointment from "../../models/domain/Appointment";
import HttpClient from "../../lib/HttpClient";

interface MessageModalProps {
  show: boolean;
  onHide: () => void;
  appointment: Appointment | null;
}

const MessageModal: React.FC<MessageModalProps> = ({
  show,
  onHide,
  appointment,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [doctorMessage, setDoctorMessage] = useState<string>("");

  useEffect(() => {
    appointment && fetchData();
  }, [appointment?.id]);

  const fetchData = async () => {
    if (!appointment?.id) return;

    try {
      setIsLoading(true);
      await getDoctorMessage(appointment.id);
    } finally {
      setIsLoading(false);
    }
  };

  const requestGetDoctorsMessage = (appointmentId: string) =>
    HttpClient.performGet<any>(
      `/api/v1/appointments/${appointmentId}/instruction`
    );

  const getDoctorMessage = async (appointmentId: string) => {
    try {
      const messageResponse = await requestGetDoctorsMessage(appointmentId);
      if (messageResponse?.body?.status?.code == "200") {
        messageResponse?.body?.messages?.[0]?.message &&
          setDoctorMessage(messageResponse?.body?.messages?.[0]?.message);
      }
    } catch (e) {
      console.error("Error fetching doctor message:", e);
    }
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      centered
      backdrop="static"
      scrollable
    >
      <Modal.Header closeButton>
        <Modal.Title>Doctors Message </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex">
          <div>
            <span className="fw-bold">Patient Name </span>:{" "}
            {appointment?.attendee_metadata.name}
          </div>
          <div className="mx-4">
            <span className="fw-bold">Patient ID </span>:{" "}
            {appointment?.attendee_metadata.app_id}
          </div>
        </div>
        <div className="mt-2" style={{ minHeight: 40 }}>
          {isLoading ? (
            <div className="d-flex justify-content-center align-items-center h-100">
              <Spinner />
            </div>
          ) : (
            <div className="d-flex">
              <span className="fw-bold me-2">Message:</span>
              {doctorMessage ? (
                <p className="mb-0">{doctorMessage}</p>
              ) : (
                <p className="mb-0">No message available.</p>
              )}
            </div>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default MessageModal;
